import { Link } from "react-router-dom";
import { Hexagon, ArrowLeft } from "lucide-react";
import FAQ from "@/components/landing/FAQ";

/**
 * Standalone FAQ page. Reuses the same FAQ component used inline on the
 * landing page (now removed from landing per request).
 */
export default function FaqPage() {
  return (
    <div className="min-h-screen bg-amber-50 text-stone-800" data-testid="faq-page">
      <header className="bg-stone-950 text-amber-50">
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group" data-testid="faq-page-home-link">
            <Hexagon className="w-6 h-6 text-amber-400 group-hover:rotate-12 transition-transform" />
            <span className="font-display text-lg font-medium tracking-tight">Hive @ Buzzzillion</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-amber-200 hover:text-amber-100 transition-colors"
            data-testid="faq-page-back-link"
          >
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
        </div>
      </header>

      <FAQ />

      <footer className="border-t border-stone-200 mt-8">
        <div className="max-w-3xl mx-auto px-6 py-10 text-center text-sm text-stone-600">
          Still have questions?{" "}
          <Link to="/register" className="text-amber-700 font-semibold hover:underline">Create an account</Link>{" "}
          to try the app free for 14 days — or open a topic in the{" "}
          <Link to="/forum" className="text-amber-700 font-semibold hover:underline">community forum</Link>.
        </div>
      </footer>
    </div>
  );
}
